import { z } from 'zod';
/**
 * Browser/device fingerprint signals for future multi-device sync.
 */
export const FingerprintSignalsSchema = z.object({
    userAgent: z.string(),
    screenWidth: z.number().int(),
    screenHeight: z.number().int(),
    colorDepth: z.number().int(),
    timezone: z.string(),
    language: z.string(),
    platform: z.string(),
    hardwareConcurrency: z.number().int(),
    deviceMemory: z.number().optional(),
    touchPoints: z.number().int(),
    pixelRatio: z.number(),
});
/**
 * Device fingerprint — ties a UUID to browser signals.
 */
export const DeviceFingerprintSchema = z.object({
    deviceId: z.string(),
    signals: FingerprintSignalsSchema,
});
//# sourceMappingURL=device-fingerprint.js.map